import React from 'react';
import './LandingBenefitsSection.css';
import centerImage from '../../../assets/images/graph.jpg'; 
import { FaChartLine, FaClock, FaHome } from 'react-icons/fa';
import { Download } from 'lucide-react';

const features = [
  {
    icon: <FaChartLine size={32} strokeWidth={2.2} />,
    title: 'Identify Trends',
    description: 'Anticipate market changes with real-time data.',
  },
  {
    icon: <FaClock size={32} strokeWidth={2.2} />,
    title: 'Save Time',
    description: 'Forget manual research. All the information you need in one place.',
  },
  {
    icon: <FaHome size={32} strokeWidth={2.2} />,
    title: 'Make Informed Decisions',
    description: 'Access in-depth analysis to minimize risks and maximize returns.',
  },
  {
    icon: <Download size={32} strokeWidth={2.2} />,
    title: 'Downloadable Reports',
    description: 'Generate PDF reports for any query for your offline analysis.',
  },
];

const LandingBenefitsSection = () => {
  return (
    <section className="landing-benefits">
      <div className="landing-benefits__overlay" />
      <div className="landing-benefits__content">
        <h2 className="landing-benefits__title">
          Real-time data, in-depth market analysis, and interactive tools designed for informed property investors.
        </h2>
        <div className="centered-image-section">
          <img
            src={centerImage}
            alt="Centered visual"
            className="centered-image"
          />
        </div>
        <div className="landing-benefits__features">
          {features.map((f, idx) => (
            <div className="landing-benefits__feature-card" key={idx}>
              <div className="landing-benefits__feature-icon">{f.icon}</div>
              <div className="landing-benefits__feature-texts">
                <div className="landing-benefits__feature-title">{f.title}</div>
                <div className="landing-benefits__feature-desc">{f.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingBenefitsSection;
